import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import RoundScreen from '../../../components/roundScreen';

export default function Page15({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen BGImage={CategoryScreenBG} titles={['Day 5', '(Leg) C.C.M.R’S']} />
			<RoundScreen
				title='Run 3 - 4 Rounds'
				isNumbered={true}
				rounds={[
					[
						{
							header: 'Type',
							value: 'Alpha',
						},
						{
							header: 'C.C.M.R’s',
							value: 'STANDARD SQUATS',
						},
						{
							header: 'REPS / Min',
							value: '6 - 8',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Mild -> Heavy',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'SISSY SQUATS',
						},
						{
							header: 'REPS / Min',
							value: '10',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Body Weight',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'SQUAT JUMPS',
						},
						{
							header: 'REPS / Min',
							value: '10',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Body Weight',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'AIR SQUATS',
						},
						{
							header: 'REPS / Min',
							value: '10',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Bodyweight / Explode',
						},
					],
				]}
			/>
			<p style={style.takeABreakTextStyle()}>Take a 1 - 2 minute break</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
